// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__20kl2","balance":"styles_balance__C7EhJ","inputMask":"styles_inputMask__1MxBi","select":"styles_select__3-Y8v","stakeBtn":"styles_stakeBtn__3VTJ3"};